import { render, staticRenderFns } from "./WarningStatusLayout.vue?vue&type=template&id=b2e1df6e&scoped=true&"
import script from "./WarningStatusLayout.vue?vue&type=script&lang=js&"
export * from "./WarningStatusLayout.vue?vue&type=script&lang=js&"
import style0 from "./WarningStatusLayout.vue?vue&type=style&index=0&id=b2e1df6e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b2e1df6e",
  null
  
)

export default component.exports